import { ReactNode } from 'react';

import { UserPermissions } from 'types';

import { useAuth } from './authProvider';

export const RequirePayoutsAccountingSettingsUser = ({ children }: { children: ReactNode }) => {
  const { claims } = useAuth();
  const isPayoutsAccountingSettingsUser = claims?.permissions?.includes(
    UserPermissions.lightReachAccountingSettings,
  );
  return isPayoutsAccountingSettingsUser ? <>{children}</> : null;
};
